import request from 'services/axios';

export function httpGetBranches(params) {
  return request.get('/api/branches/', { params });
}

export function httpGetBranch(id) {
  return request.get(`/api/branches/${id}/`);
}

export function httpPostBranch(dto) {
  return request.post('/api/branches/', dto);
}

export function httpPutBranch({ id, ...dto }) {
  return request.put(`/api/branches/${id}/`, dto);
}

export function httpPatchBranch({ id, ...dto }) {
  return request.patch(`/api/branches/${id}/`, dto);
}

export function httpDeleteBranch(id) {
  return request.delete(`/api/branches/${id}/`);
}
